import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import wrapElement from '../helpers/wrapElement';

const WRAP_CLASS = 'embed-wrap';
const ALLOWED_ORIGINS = ['youtube', 'youtu.be', 'vimeo'];

class EmbedWrap extends Controller {
  connect() {
    this.check();
  }

  check() {
    const elements = EmbedWrap.embeddableElements(this.element);

    elements.forEach((element) => {
      if (EmbedWrap.isWrapped(element) || !EmbedWrap.isWrappable(element)) {
        return;
      }

      EmbedWrap.wrap(element);
    });
  }

  static wrap(element) {
    const wrapper = document.createElement('div');
    wrapper.className = WRAP_CLASS;
    wrapper.style.paddingBottom = `${EmbedWrap.embedRatio(element)}%`;

    wrapElement(element, wrapper);
  }

  static embeddableElements(containerElement) {
    return toArray(containerElement.querySelectorAll('iframe, video'));
  }

  static isWrappable(element) {
    if (element.className.indexOf('no-wrap') >= 0) {
      return false;
    }

    if (element.tagName === 'VIDEO') {
      return true;
    }

    return EmbedWrap.isWrappableSource(element);
  }

  static isWrappableSource(element) {
    const source = element.getAttribute('src');

    return ALLOWED_ORIGINS.filter((origin) => (
      source.indexOf(origin) >= 0
    )).length > 0;
  }

  static isWrapped(element) {
    return element.parentNode.className.indexOf(WRAP_CLASS) >= 0;
  }

  static embedRatio(element) {
    let ratio = 56.25;

    if (element.getAttribute('width') && element.getAttribute('height')) {
      const width = parseInt(element.getAttribute('width'), 10);
      const height = parseInt(element.getAttribute('height'), 10);

      if (!Number.isNaN(width) || !Number.isNaN(height)) {
        ratio = (height / width) * 100;
      }
    }

    return ratio;
  }
}

EmbedWrap.targets = [
  //
];

export default EmbedWrap;
